import { useMemo } from "react"
import { LICENSE_STATUS_NONE } from "@/v2-backoffice-client/license/license.constants"
import { getLicenseGoverningStatusLabel } from "@/v2-backoffice-client/license/license.utils"
import { useLicenseStatusesQuery } from "@/v2-backoffice-client/license/license.statuses.query"

export type LicenseStatusFilterOption = { label: string; value: string }

/**
 * The seeded license statuses as every governing-status column needs
 * them: the display name per code for the badge, and the filter options
 * with "No license" appended, the sentinel the board procs emit for a
 * customer that holds none. Two option lists because the two table modes
 * compare different things: a server-paged board sends the code to the Go
 * filter registry, a client-side table compares against the label its
 * getValue returns.
 */
export function useLicenseGoverningStatuses() {
  const { data } = useLicenseStatusesQuery()
  const statuses = data?.getLicenseStatuses

  return useMemo(() => {
    const namesByCode = new Map(
      (statuses ?? []).map((status) => [status.Code, status.Name]),
    )
    const noLicenseLabel = getLicenseGoverningStatusLabel(
      LICENSE_STATUS_NONE,
      namesByCode,
    )
    return {
      statuses,
      namesByCode,
      codeOptions: [
        ...(statuses ?? []).map((status) => ({
          label: status.Name,
          value: String(status.Code),
        })),
        { label: noLicenseLabel, value: String(LICENSE_STATUS_NONE) },
      ] satisfies LicenseStatusFilterOption[],
      labelOptions: [
        ...(statuses ?? []).map((status) => ({
          label: status.Name,
          value: status.Name,
        })),
        { label: noLicenseLabel, value: noLicenseLabel },
      ] satisfies LicenseStatusFilterOption[],
    }
  }, [statuses])
}
